import React from "react";
import ManageToiture from "../ManageBeStep/Components/ManageToiture";

const BeCreateProject = () => {

    return(
        <>
        <div className="content-body">
            <div className="container-fluid">
                <ManageToiture />
            </div>
        </div>
        </>
    )

}

export default BeCreateProject;